/* tslint:disable */
/* eslint-disable */
/**
 * Sunshine Auction API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AdminEbayAspect
 */
export interface AdminEbayAspect {
    /**
     * 
     * @type {number}
     * @memberof AdminEbayAspect
     */
    maxLength?: number;
    /**
     * Multiple: the item may have several values.
     * @type {boolean}
     * @memberof AdminEbayAspect
     */
    multiple: boolean;
    /**
     * 
     * @type {string}
     * @memberof AdminEbayAspect
     */
    name: string;
    /**
     * Recommended: eBay recommends filling it in.
     * @type {boolean}
     * @memberof AdminEbayAspect
     */
    recommended: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AdminEbayAspect
     */
    required: boolean;
    /**
     * SelectionOnly: the value must be one of Values; otherwise Values are suggestions.
     * @type {boolean}
     * @memberof AdminEbayAspect
     */
    selectionOnly: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminEbayAspect
     */
    values: Array<string>;
}

export function AdminEbayAspectFromJSON(json: any): AdminEbayAspect {
    return AdminEbayAspectFromJSONTyped(json, false);
}

export function AdminEbayAspectFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminEbayAspect {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'maxLength': !exists(json, 'maxLength') ? undefined : json['maxLength'],
        'multiple': json['multiple'],
        'name': json['name'],
        'recommended': json['recommended'],
        'required': json['required'],
        'selectionOnly': json['selectionOnly'],
        'values': json['values'],
    };
}

export function AdminEbayAspectToJSON(value?: AdminEbayAspect | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'maxLength': value.maxLength,
        'multiple': value.multiple,
        'name': value.name,
        'recommended': value.recommended,
        'required': value.required,
        'selectionOnly': value.selectionOnly,
        'values': value.values,
    };
}

